class NsInputterEvent extends Event {
  constructor(NucleusCustonEvent) {
    const {
      target,
      type,
      detail,
      bubbles,
      cancelable,
      composed
    } = NucleusCustonEvent;
    super(type, {
      bubbles,
      cancelable,
      composed
    });

    const name = target?.getAttribute('name');
    const value = detail?.value;
    const processedValue = this.#processedValue(NucleusCustonEvent);
    const newTarget = Object.assign(target, {
      name,
      value,
      processedValue
    });

    Object.defineProperties(this, {
      target: {
        value: newTarget,
        writable: false
      },
      detail: {
        value: detail,
        writable: false
      }
    });
  }

  #processedValue(event) {
    const { target } = event;
    const tagName = target?.tagName;
    const ignoreseparator = target?.ignoreSeparator;

    const separator = target?.separator;
    const { value } = event.detail;

    if (tagName === 'NS-DATEPICKER') {
      return value;
    }

    return ignoreseparator
      ? value.replace(new RegExp(separator, 'g'), '')
      : value;
  }
}

export default NsInputterEvent;
